export const getEarliestDate = arrayValues =>
  arrayValues.filter(value => value).sort((a, b) => Date.parse(b) - Date.parse(a))[0];
